<app-default>
  <div class="container pt-5 pb-5">
    <h1 class="title">Phương thức giao – nhận hàng</h1>
    <p>Tùy thuộc mức độ hư hỏng, mất mát và tính nghiêm trọng, ảnh hưởng của sự cố và những điều kiện thỏa thuận mà hai bên đã thỏa thuận để đền bù theo quy định.</p>
  </div>
</app-default>
